"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDocument = void 0;
function isDocument(node) {
    return node.nodeName === '#document';
}
exports.isDocument = isDocument;
